import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import { AccountantYear } from "../../../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { BasicButton } from "../../../theme/Component/BasicButton";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { _BankingCheck, _CreateMovementTax, _CreateMovementTaxNote, _FinancialMovementTax, _ImportBankingCheck, _ObligationForFinancial } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BankAccountSelect } from "../../../erp/cellEditor/BankAccount/BankAccountSelect";
import { DocumentStorageEditor } from "../../../contabilidad/bodegaDocumentos/DocumentStorageEditor";
import { _DocumentFactory, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { InputDate } from "../../../theme/Input/InputDate";
import { SelectProccessTypeConstants } from "../../../erp/cellEditor/CashRequest/FactoryDocument/SelectProccessTypeConstants";
import { FileInput } from "../../../theme/Component/FileInput";
import { FinancialMovementTaxEditorStet } from "./FinancialMovementTaxEditorStet";
import { FinancialTaxSchemeCatalog } from "./FinancialTaxSchemeCatalog";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { DocumentHeaderEditor } from "../../../contabilidad/bodegaDocumentos/DocumentHeaderEditor";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { FinancialMovementTaxStateTreasure } from "./FinancialMovementTaxStateTreasure";
import { BasicMultiSelectTable } from "../../../theme/Component/BasicMultiSelecTable";
import { AccountEditor } from "../../../editor/AccountEditor";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { DropDown } from "../../../theme/Component/DropDown";
import useModal, { MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";




export const FinancialMovementTaxTreasure = () => {

    const financial = useDataBean(_FinancialMovementTax);
    const createfinancial = useDataBean(_CreateMovementTax);
    const createfinancialnote = useDataBean(_CreateMovementTaxNote);
    const settax = useDataBean(_ObligationForFinancial);
    const single = Singleton.getInstance();
    const [listaResult, setListaResult] = useState<any>([]);
    const [listafinal, setListafinal] = useState<any>([]);
    const [docs, setDocs] = useState<any>([]);
    const [docstwo, setDocstwo] = useState<any>([]);
    const [documentstres, setDocumentstres] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [documents, setDocuments] = useState<any>([]);
    const [documentstwo, setDocumentstwo] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const [listE, setListE] = useState<any>([]);
    const [modalviewdoctres, setModalviewdoctres] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcreate, setModalcreate] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdocobli, setModalverdocobli] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverobli, setModalverobli] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdocnote, setModalverdocnote] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalvernote, setModalvernote] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaladd, setModaladd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalviewdocadd, setModalviewdocadd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalviewdoc, setModalviewdoc] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalgenerate, setModalgenerate] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalimp, setModalimp] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalasing, setModalasing] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [Year, setYear] = useState<any>(_single.getCurrenYear())
    const [month, setMonth] = useState<any>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [state, setstate] = useState<any>(3)
    const [processType, setprocessType] = useState<any>(null)
    const paginador = usePaginator();
    const modalExportList = useModal("Exportar Historial", MODAL_SM);


    useEffect(() => {
        getLista();
    }, [paginador.page])

    useEffect(() => {
        if (modalverobli.view) {
            verDocumentos();
        }
    }, [modalverobli.view]);

    useEffect(() => {
        if (modalvernote.view) {
            verDocumentosvdos();
        }
    }, [modalvernote.view]);

    const verDocumentos = () => {

        if (financial.bean.OBIDDocument) {
            _documentos.instance.getPdfAccountantDocument(financial.bean.OBIDDocument, null, financial.bean.OBDocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModalverdocobli({ ...modalverdocobli, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }


    const verDocumentosvdos = () => {

        if (financial.bean.IDDocument) {
            _documentos.instance.getPdfAccountantDocument(financial.bean.IDDocument, null, financial.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocstwo(resp.DocumentURL);
                    setModalverdocnote({ ...modalverdocnote, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const getLista = () => {

        financial.instance.getFinancialMovementTaxReportForTreasure(_single.getAccountID(), processType, Year, month, state, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.OB = (user.DataBeanProperties.OBMnemonic ?? "") + "-" + (user.DataBeanProperties.OBConsecutive ?? "");
                        user.DataBeanProperties.Note = (user.DataBeanProperties.Mnemonic ?? "") + "-" + (user.DataBeanProperties.Consecutive ?? "");;

                    });
                    setLista(x)
                }

            }
        )

    }

    const getListaReport = () => {
        financial.instance.getFinancialMovementTaxReportForTreasure(_single.getAccountID(), processType, Year, month, state, regexStr, 1, paginador.pages * 15).then(
            (resp: any) => {
                if (resp) {
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.OB = (user.DataBeanProperties.OBMnemonic ?? "") + "-" + (user.DataBeanProperties.OBConsecutive ?? "");
                        user.DataBeanProperties.Note = (user.DataBeanProperties.Mnemonic ?? "") + "-" + (user.DataBeanProperties.Consecutive ?? "");;

                    });
                    setListE(x)
                }

            }
        )
    }

    const createOBFinancialMovementTax = () => {
        createfinancial.instance.createOBFinancialMovementTax(financial.bean.IDFinancialMovementTax, financial.bean.AccountantDate, createfinancial.bean.IDDocument, createfinancial.bean.DocumentDate, createfinancial.bean.ExternalConsecutive, createfinancial.bean.Description, _single.getAccountID()).then(
            (resp: any) => {
                setModalgenerate({ ...modalgenerate, "view": false });
                setModalviewdoc({ ...modalviewdoc, "view": true });
                setDocuments(resp.DocumentURL);
                // ✅ Mostrar cada mensaje del backend en un toast
                resp.MsgList?.forEach((msg: string) => {
                    toast.info(msg);
                });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const createBankingNoteDocumentForFinancialTaxMovements = () => {
        createfinancialnote.instance.createBankingNoteDocumentForFinancialTaxMovements(createfinancialnote.bean.IDBankingAccount, createfinancialnote.bean.IDAccount, createfinancialnote.bean.AccountantDate, listaResult, createfinancialnote.bean.Description, _single.getAccountID()).then(
            (resp: any) => {
                setModalcreate({ ...modalcreate, "view": false });
                setModalviewdoctres({ ...modalviewdoctres, "view": true });
                setDocumentstres(resp.DocumentURL);
                // ✅ Mostrar cada mensaje del backend en un toast
                resp.MsgList?.forEach((msg: string) => {
                    toast.info(msg);
                });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const setObligationForFinancialMovementTax = () => {
        settax.instance.setObligationForFinancialMovementTax(financial.bean.IDFinancialMovementTax, financial.bean.AccountantDate, settax.bean.OBIDDocument, settax.bean.OBDocumentDate, _single.getAccountID()).then(
            (resp: any) => {
                setModaladd({ ...modaladd, "view": false });
                setModalviewdocadd({ ...modalviewdocadd, "view": true });
                setDocumentstwo(resp.DocumentURL);
                // ✅ Mostrar cada mensaje del backend en un toast
                resp.MsgList?.forEach((msg: string) => {
                    toast.info(msg);
                });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        financial.setBean({

            IDEmployee: _single.getAccountID()
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        if (!financial.bean.AccountantDate) {
            toast.warning("Debe seleccionar una Fecha Proceso.");
            return;
        }
        if (!financial.bean.IDTaxScheme) {
            toast.warning("Debe seleccionar un Tipo de Impuesto Financiero.");
            return;
        }
        if (!financial.bean.ProcessType) {
            toast.warning("Debe seleccionar un Tipo de Proceso.");
            return;
        }
        if (!financial.bean.Value) {
            toast.warning("Debe seleccionar un Valor Impuesto Financiero.");
            return;
        }
        financial.instance.updateFinancialMovementTax(financial.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        financial.instance.deleteFinancialMovementTax(financial.bean.IDFinancialMovementTax, financial.bean.AccountantDate).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const vercreate = () => {
        createfinancialnote.setBean({

        });
        setModalcreate({ ...modalcreate, "view": true });

    }
    const head = [
        { title: 'ID', property: 'IDFinancialMovementTax', visible: true },
        { title: 'Fecha Proceso', property: 'AccountantDate', visible: true, },
        { title: 'Tipo de Impuesto Financiero', property: 'TaxSchemeName', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true, },
        { title: 'Valor Impuesto Financiero', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Estado', property: 'StateName', visible: true, },
        { title: 'Obligación Presupuestal', property: 'OB', visible: true, },
        { title: 'Fecha Obligación', property: 'OBDocumentDate', visible: true, },
        { title: 'Nota Débito', property: 'Note', visible: true, },
        { title: 'Fecha', property: 'DocumentDate', visible: true, },
        { title: 'Usuario Logueado', property: 'EmployeeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Generar Obligación Presupuestal', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalgenerate({ ...modalgenerate, "view": true }) } },
            { titulo: 'Agregar Obligación Presupuestal', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModaladd({ ...modaladd, "view": true }) } },
            { titulo: 'Consultar Obligación Presupuestal', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalverobli({ ...modalverobli, "view": true }) } },
            { titulo: 'Consultar Nota Débito', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalvernote({ ...modalvernote, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Exportar', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={buttonEvent}></DropDown>
                </div>
            </div>
        )
    }
    const buttonEvent = (e) => {
        if (e.id === 1) {
            getListaReport();
            modalExportList.open();

        }

    }

    return (
        <BasicPage titulo="Generar Notas Débito para Gastos Financieros desde Obligaciones">
            <div className="row">
                <div className="col-md-6">
                    <SelectProccessTypeConstants label='Tipo de Proceso' idSelector={processType} onChange={(e) => { setprocessType(e) }} />
                </div>
                <div className="col-md-6">
                    <AccountantYear idSelector={Year} label="Año" onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-6">
                    <MonthEditorbyconst idSelector={month} onChange={(e) => { setMonth(e) }} />
                </div>
                <div className="col-md-6">
                    <FinancialMovementTaxStateTreasure idSelector={state} onChange={(e) => { setstate(e) }} />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-6">
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={vercreate}>
                        Generar Nota Bancaria
                    </BasicButton>
                </div>
                <div className="col-md-12">

                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={financial.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>

                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <InputDate name="AccountantDate" label="Fecha Proceso" value={financial.bean.AccountantDate} setDate={(e: any) => { financial.setBean({ ...financial.bean, "AccountantDate": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <FinancialTaxSchemeCatalog render={financial.bean.Name} idSelector={financial.bean.IDTaxScheme} onChange={(e) => { financial.setBean({ ...financial.bean, "IDTaxScheme": e.IDTaxScheme, "Name": e.Name }) }} returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <SelectProccessTypeConstants label='Tipo de Proceso' idSelector={financial.bean.ProcessType} onChange={(e) => { financial.setBean({ ...financial.bean, "ProcessType": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Valor Impuesto Financiero</label>
                                    <InputMoney _value={financial.bean.Value} onChange={(e: any) => { financial.setBean({ ...financial.bean, 'Value': e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={financial.bean.Description} onChange={financial.handleChange} />
                                </div>
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modalgenerate} updateModal={setModalgenerate} eventModal={createOBFinancialMovementTax}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentHeaderEditor label="RP Seleccionado" onChange={(e) => { createfinancial.setBean({ ...createfinancial.bean, "IDDocument": e.IDDocument, "DocumentDate": e.Since, "DocumentState": e.DocumentState, "Consecutive": e.Consecutive, "Mnemonic": e.Mnemonic, }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Consecutivo Externo</label>
                                    <input type='text' name="ExternalConsecutive" className="form-control" value={createfinancial.bean.ExternalConsecutive} onChange={createfinancial.handleChange} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={createfinancial.bean.Description} onChange={createfinancial.handleChange} />
                                </div>
                            </div>
                        </>
                    </Modal>

                    <Modal modal={modalExportList.modal} updateModal={modalExportList.setModal}>
                        {listE.length > 0 &&
                            <ExportXLSL customName={"NotasDebito"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listE} onExport={(name: string) => {
                                single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                            }} />
                        }
                    </Modal>

                    <Modal modal={modalcreate} updateModal={setModalcreate} eventModal={createBankingNoteDocumentForFinancialTaxMovements}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <BankAccountSelect label='Banco Orígen' idSelector={createfinancialnote.bean.IDBankingAccount} onChange={(e) => { createfinancialnote.setBean({ ...createfinancialnote.bean, "IDBankingAccount": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <AccountEditor label="Beneficiario" idAccount={createfinancialnote.bean.IDAccount} onChange={(e) => { createfinancialnote.setBean({ ...createfinancialnote.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>
                                <div className="col-md-6">
                                    <InputDate name="AccountantDate" label="Fecha de Registro Contable" value={createfinancialnote.bean.AccountantDate} setDate={(e: any) => { createfinancialnote.setBean({ ...createfinancialnote.bean, "AccountantDate": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <BasicMultiSelectTable body={lista} head={head} bodyResult={listaResult} keyId="IDFinancialMovementTax" updateValues={({ bodyResult }) => {
                                        const newLista = bodyResult.map(data => ({
                                            DataBeanProperties: data.DataBeanProperties,
                                            DataBeanName: "com.quickdataerp.bean.tax.FinancialMovementTax"
                                        }));
                                        setListaResult(newLista);
                                        console.log(newLista)
                                    }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={createfinancialnote.bean.Description} onChange={createfinancialnote.handleChange} />
                                </div>
                            </div>
                        </>
                    </Modal>
                    <div className="col-md-12">
                        <Modal modal={modalverdocobli} updateModal={setModalverdocobli}>
                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentViewer
                                        list={docs}
                                        IDDocument={financial.bean.OBIDDocument}
                                        Since={financial.bean.OBDocumentDate}
                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalverdocnote} updateModal={setModalverdocnote}>
                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentViewer
                                        list={docstwo}
                                        IDDocument={financial.bean.IDDocument}
                                        Since={financial.bean.DocumentDate}
                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalviewdoctres} updateModal={setModalviewdoctres}>
                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentViewer
                                        list={documentstres}
                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <Modal modal={modaladd} updateModal={setModaladd} eventModal={setObligationForFinancialMovementTax}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentStorageEditor mNemonic="OB" onChange={(e) => { settax.setBean({ ...settax.bean, 'OBIDDocument': e.IDDocument, 'OBDocumentDate': e.DocumentDate }) }} label="Obligación" />
                                </div>
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modalviewdoc} updateModal={setModalviewdoc}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={documents}
                                    IDDocument={createfinancial.bean.IDDocument}
                                    Since={createfinancial.bean.DocumentDate}
                                />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalviewdocadd} updateModal={setModalviewdocadd}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={documentstwo}
                                    IDDocument={settax.bean.OBIDDocument}
                                    Since={settax.bean.OBDocumentDate}
                                />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate name="AccountantDate" label="Fecha Proceso" value={financial.bean.AccountantDate} setDate={(e: any) => { financial.setBean({ ...financial.bean, "AccountantDate": e }) }} />
                            </div>
                        </div>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}